import { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';
import isFunction from 'utils/isFunction';

export default function useDebounceMutation(delay = 1000) {
  const [debounceDelay, setDebounceDelay] = useState();

  useEffect(() => {
    setDebounceDelay(delay);
  }, [delay]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceUpdate = useCallback(
    debounce((update, variables, onError) => {
      update({ variables }).catch((err) => {
        if (isFunction(onError)) onError(err);
        else throw err;
      });
    }, debounceDelay),
    [debounceDelay]
  );

  return [debounceUpdate];
}
